import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  createStudentsAPIEndpoint,
  EndPoints,
} from "../../../../services/StudentAPIs";

function StudentDetailsDialog({
  openDialog,
  handleCloseDialog,
  selectedStudent,
}) {
  const handleDownloadQRCode = (studentId) => {
    createStudentsAPIEndpoint(EndPoints.getStudentQRCode(studentId))
      .fetch({ responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.setAttribute(
          "download",
          `student_${selectedStudent.fullName}_${selectedStudent.centerName}_qrcode.pdf`,
        );
        document.body.appendChild(link);
        link.click();

        link.remove();
        document.body.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error("Error downloading QR code:", error);
      });
  };

  
  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      className="student-dialog"
    >
      <DialogContent className="student-detail-content">
        <DialogTitle className="student-dialog-title">
          Student Details
        </DialogTitle>
        <DialogContent dividers>
          {selectedStudent ? (
            <Box className="student-detail-container">
              <Typography className="Id">
                <span className="student-detail-label">ID:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.id}
                </span>
              </Typography>
              <Typography>
                <span className="student-detail-label">Username:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.userName}
                </span>
              </Typography>
              <Typography>
                <span className="student-detail-label">Full Name:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.fullName}
                </span>
              </Typography>
              <Typography>
                <span className="student-detail-label">PhoneNumber:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.phoneNumber || "N/A"}
                </span>
              </Typography>
              <Typography>
                <span className="student-detail-label">
                  Parent Phone Number:
                </span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.parentNumber || "N/A"}
                </span>
              </Typography>

              <Typography>
                <span className="student-detail-label">Education Stage:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.educationStage}
                </span>
              </Typography>
              <Typography>
                <span className="student-detail-label">Center:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.centerName || "N/A"}
                </span>
              </Typography>

              <Typography>
                <span className="student-detail-label">Status:</span>{" "}
                <span className="student-detail-value">
                  {selectedStudent.isActive ? "Active" : "Inactive"}
                </span>
              </Typography>
              <Button
                variant="contained"
                className="btn-download-qr"
                onClick={() => handleDownloadQRCode(selectedStudent.id)}
              >
                Download QR
              </Button>
            </Box>
          ) : (
            <Typography>No data available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button className="btn-close" onClick={handleCloseDialog}>
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default StudentDetailsDialog;
